var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompaniesIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M56.4038 102.667C55.8259 102.667 55.2481 102.534 54.7266 102.264L37.9215 93.5648C33.1529 91.0938 29.4226 88.3206 26.5098 85.0899C20.1344 78.0245 16.5874 68.9547 16.531 59.5462L16.3337 28.5799C16.3102 25.006 18.617 21.7981 22.0654 20.59L52.9225 9.83167C54.7548 9.17729 56.7984 9.16814 58.6636 9.79964L89.6382 20.1919C93.1054 21.3497 95.4497 24.5346 95.4685 28.104L95.6658 59.0932C95.7269 68.4879 92.302 77.5943 86.0253 84.7376C83.1454 88.0141 79.448 90.8283 74.7264 93.3452L58.0716 102.241C57.5548 102.52 56.9817 102.662 56.4038 102.667Z",
    fill: "#136BFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8229 66.8309C51.9208 66.8355 51.0188 66.5106 50.3235 65.8425L41.3783 57.2395C39.9971 55.9032 39.983 53.7342 41.3501 52.3888C42.7173 51.0389 44.9489 51.0251 46.3348 52.3568L52.7712 58.5436L68.4864 43.049C69.8582 41.6991 72.0898 41.6854 73.471 43.017C74.857 44.3532 74.8711 46.5268 73.5039 47.8676L55.3082 65.8105C54.6223 66.4877 53.7249 66.8263 52.8229 66.8309Z",
    fill: "#136BFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompaniesIcon3);
export default __webpack_public_path__ + "static/media/companies-icon-3.db8e14ef9e712b5c05a5f0535bb1665f.svg";
export { ForwardRef as ReactComponent };